import { AnswerType } from 'app/modules/playbook/constants'

import PlaybookModal from '../PlaybookModal'

import AnswerModalStandardBody from './AnswerModalStandardBody'
import AnswerModalMatchBody from './AnswerModalMatchBody'
import AnswerModalNonMatchBody from './AnswerModalNonMatchBody'

import style from './style.styl'

const AnswerModal = ({
  answer: { response, type },
  questionIndex,
  isEmailCaptureQuestion,
  isPhoneCaptureQuestion,
  onCloseClick,
  onResponseChange,
  targetCopy,
  shortTargetCopy,
}) => {
  const title = isEmailCaptureQuestion
    ? `Email Capture ${questionIndex + 1}`
    : isPhoneCaptureQuestion ? `Phone Capture ${questionIndex + 1}` : `Question ${questionIndex + 1}`

  const botFollowUpProps = { response, questionIndex, onResponseChange }

  const modalBody =
    isEmailCaptureQuestion || isPhoneCaptureQuestion ? type === AnswerType.VALIDATE ? (
      <AnswerModalMatchBody botFollowUpProps={botFollowUpProps} targetCopy={targetCopy} shortTargetCopy={shortTargetCopy} />
    ) : (
      <AnswerModalNonMatchBody botFollowUpProps={botFollowUpProps} targetCopy={targetCopy} shortTargetCopy={shortTargetCopy} />
    ) : (
      <AnswerModalStandardBody botFollowUpProps={botFollowUpProps} />
    )

  return (
    <PlaybookModal
      onCloseClick={onCloseClick}
      hideDescription
      title={`${title}`}
      contentClassName={style.AnswerModalContent}
    >
      <div>
        {modalBody}
      </div>
    </PlaybookModal>
  )
}

export default AnswerModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/component.js